import * as React from "react";
import {cva, type VariantProps} from "class-variance-authority";

import {cn} from "@/lib/utils";

const tagVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        primary:
          "border-transparent bg-primary-background text-primary-accent shadow",
        secondary:
          "bg-slate-500/12 text-secondary-foreground shadow border-transparent",
        tertiary: "bg-transparent font-normal text-gray-500 border-gray",
        outline: "bg-white text-label shadow border-border",
        info: "bg-blue-700/12 text-blue-900 shadow border-transparent",
        destructive: "bg-red-700/12 text-red-900 shadow border-transparent",
        success: "bg-green-700/12 text-green-700 shadow border-transparent",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  },
);

export interface TagProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof tagVariants> {}

const Tag: React.FC<TagProps> = ({className, variant, ...props}: TagProps) => {
  return (
    <div
      className={cn(
        "px-1.5 font-medium text-xs",
        tagVariants({variant}),
        className,
      )}
      {...props}
    />
  );
};

export {Tag, tagVariants};
